
      if (import.meta.env?.MODE) {
        await import("/src/App.jsx");
      } else {
        const { default: babel } = await import("@babel/standalone");
        const source = await fetch("./src/App.jsx").then((r) => r.text());
        const compiled = babel.transform(source, {
          filename: "App.jsx",
          presets: [["react", { runtime: "classic" }]],
          sourceType: "module"
        }).code;
        const blob = new Blob([compiled], { type: "text/javascript" });
        await import(URL.createObjectURL(blob));
      }
    